export const ROUTES = {
	home: '/',
	signup: '/signup',
	otp: '/otp',
	chooseSubscription: '/choose-subscription',
	finalizeSubscription: '/finalize-subscription',
	privacyPolicy: '/privacy-policy',
	termsAndConditions: '/terms-and-conditions',
};

export const HASH_ROUTES = {
	home: 'home',
	features: 'features',
	metrix: 'metrix',
	download: 'download',
	pricing: 'pricing',
	faq: 'faq',
	contact: 'contact',
	footer: 'footer',
};
